import React, { useState } from 'react'
import { Box, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import TechMidView from './TechMidView';
import TechMidEditFormContainer from '../../../containers/techmng/support/TechMidEditFormContainer';

import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { listMidTechs } from '../../../modules/techModule/techMids';
import AskDialog from '../../common/dialog/AskDialog';
import * as techApi from '../../../lib/api/tech';

const TechMidTemplate = ({ tech, techMid, user }) => {

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [mode, setMode] = useState("view");

    const changeMode = (mode) => {
        setMode(mode);
    }

    const [visible, setVisible] = useState(false);

    const onDelete = () => {
        setVisible(true);
    }
    const onCancle = () => {
        setVisible(false);
    };

    const onConfirm = (id) => {
        setVisible(false);
        onRemove();
    };

    const onRemove = async () => {
        //console.log(techMid.rptUuid);
        try {
            const res = await techApi.deleteTechMid(techMid.rptUuid);

            if (res.data.result === 'success') {
                const searchData = { "reqUuid": techMid?.reqUuid, "planUuid": techMid?.planUuid, "prjUuid": techMid?.prjUuid };
                dispatch(listMidTechs(searchData))
            }
            enqueueSnackbar('기술지원  중간 보고서 삭제 성공', {
                variant: 'success',
            });
        } catch (err) {
            let message =
                err.response !== 'undefined' ? err.response?.data?.message : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
    }
    if (!techMid) {
        return null
    }


    return (
        <Box>
            {mode === 'view' ? (
                <Box>
                    {user?.usrUuid === techMid.crtUsr && Number(tech?.reqGrade) < 4 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <IconButton color="error" aria-label="delete" onClick={onDelete}><DeleteIcon /></IconButton>
                            <IconButton color="primary" aria-label="edit" onClick={() => changeMode('edit')}><EditIcon /></IconButton>
                        </Box>
                    )}

                    <Box><TechMidView techMid={techMid} /></Box>
                </Box>

            ) : (
                <Box>
                    <TechMidEditFormContainer techMid={techMid} changeMode={changeMode} />
                </Box>


            )}
            <AskDialog
                visible={visible}
                title="중간보고서 삭제"
                description="선택한 중간보고를 삭제하시겠습니까?"
                confirmText="삭제"
                onConfirm={onConfirm}
                onCancle={onCancle}
            />
        </Box>
    )
}

export default TechMidTemplate